<template>
    <a-tabs v-model:activeKey="activeKey" size="large" @change="onChange"  @tabClick="onTabClick">
        <a-tab-pane key="1" tab="使用辅导" ></a-tab-pane>
        <a-tab-pane key="2" tab="未领取待邀评订单"></a-tab-pane>
        <a-tab-pane key="3" tab="已领取待邀评订单"></a-tab-pane>
        <a-tab-pane key="4" tab="邀评业绩"></a-tab-pane>
        <a-tab-pane key="5" tab="客服邀评绩效"></a-tab-pane>
        <a-tab-pane key="6" tab="信息查询工具"></a-tab-pane>
        <!--a-tab-pane key="9" tab="百灵软件发飞鸽消息教程"></a-tab-pane-->
    </a-tabs>
  </template>
  <script>
  import { defineComponent, ref } from 'vue';
  export default defineComponent({
    setup() {
      return {
        
      };
    },
    data(){
        return {
            activeKey: ref('1')
        }
    },
    props:['checktab'],
    mounted(){
        let num = this.checktab;
        this.activeKey = ref(num);
    },
    methods:{
        onTabClick(tabKey) {
              //console.log("tab clicked : " + tabKey);
          },
          onChange(tabKey) {
              //console.log("tab changed : " + tabKey);
              if(parseInt(tabKey) == 1) this.$router.push('/RengongInfo')
              if(parseInt(tabKey) == 2) this.$router.push('/RengongWlq')
              if(parseInt(tabKey) == 3) this.$router.push('/RengongYlqRw')
              if(parseInt(tabKey) == 4) this.$router.push('/RengongCPKPI')
              if(parseInt(tabKey) == 5) this.$router.push('/RengongGrKPI')
              if(parseInt(tabKey) == 6) this.$router.push('/RengongCXTool')
              if(parseInt(tabKey) == 7) this.$router.push('/RengongFeigeMessageList')
              if(parseInt(tabKey) == 8) this.$router.push('/RengongFeigeSendList')
              if(parseInt(tabKey) == 9) this.$router.push('/RengongBailing')
          }
    }
  });
  </script>
  <style>
  
  </style>